import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import SystemCommand from '@/types/SystemCommand';

const MsgBox = (props: { text: string; timestamp: Date }) => {
  const sentTime = new Date(props.timestamp);
  return (
    <Box mx={4}>
      <Box height="4px" />
      <Box display="grid" gridTemplateColumns="1fr auto 1fr">
        <Typography
          gridColumn={2}
          variant="caption"
          color={(t) => t.palette.grey[600]}
        >
          {`${sentTime.getHours().toString().padStart(2, '0')}:${sentTime
            .getMinutes()
            .toString()
            .padStart(2, '0')}`}
        </Typography>
      </Box>
      <Box
        sx={{
          border: 1,
          borderRadius: 10,
          borderColor: (t) => t.palette.grey[500],
          maxWidth: 400,
          mx: 'auto',
        }}
      >
        <Typography
          variant="body2"
          textAlign="center"
          sx={{ color: (t) => t.palette.grey[700] }}
        >
          {props.text}
        </Typography>
      </Box>
      <Box height="8px" />
    </Box>
  );
};

const SystemMessage = (props: {
  command: string;
  timestamp: Date;
  canGuideControl: boolean;
  getUserName: (userId: string) => string | undefined;
  isProjectionMode: boolean;
}) => {
  const { t } = useTranslation('chat');

  if (props.isProjectionMode === false) {
    try {
      const command = JSON.parse(props.command) as SystemCommand;
      if (command.commandType === 'clearChat' && props.canGuideControl) {
        return (
          <MsgBox
            text={t('systemMessage.clearedScreen')}
            timestamp={props.timestamp}
          />
        );
      } else if (command.commandType === 'muteUserMic') {
        return (
          <MsgBox
            text={t('systemMessage.mutedAllMics')}
            timestamp={props.timestamp}
          />
        );
      } else if (command.commandType === 'joinUser') {
        const userName = props.getUserName(command.userId);
        if (userName) {
          return (
            <MsgBox
              text={t('systemMessage.joinedUser', {
                name: userName,
              })}
              timestamp={props.timestamp}
            />
          );
        }
      } else if (command.commandType === 'leaveUser') {
        const userName = props.getUserName(command.userId);
        if (userName) {
          return (
            <MsgBox
              text={t('systemMessage.leftUser', {
                name: userName,
              })}
              timestamp={props.timestamp}
            />
          );
        }
      }
    } catch (e: any) {
      //パースに失敗するケースを考慮
      console.error(e);
    }
  }
  // 高さが0にならないような空欄を返却。通常はこれが表示されることはない。
  // joinUserやremoveChatSessionUserなど表示対象外のものは、そもそもリストから除外されている前提とする。
  // (例えmarginやpaddingを工夫しても、結局高さが0になるなら動作に問題が出る)
  return <Box height="1px" />;
};
export default SystemMessage;
